import React from "react";
import { Redirect, Route, BrowserRouter as Router, Switch } from "react-router-dom";

// COMPONENTS
import Footer from "./components/Footer";
import useToken from "./components/useToken";
import Auth from "./pages/auth";
import Contatos from "./pages/contatos";
import Gpr from "./pages/gpr";

// STYLES
import './styles/app.css';

function App() {

  const { token, setToken } = useToken();
  const url = window.location.pathname;

  if (!token && url.indexOf('/gprf') > -1) {
    return (
      <div className="d-flex flex-column min-vh-100">
        <div className="flex-grow-1">
          <Auth setToken={setToken} modulo={"GPRF"} />
        </div>
        <Footer />
      </div>
    );
  }
  // if (!token && url.indexOf('/gpr') > -1) {
  //   return <Auth setToken={setToken} modulo={"GPR"} />
  // }

  const logoff = () => setToken(null);

  return (
    <Router basename={process.env.REACT_APP_BASENAME}>
      <div className="d-flex flex-column min-vh-100">
        <div className="flex-grow-1">
          <Switch>
            <Route path="/contatos-zes" exact>
              <Contatos />
            </Route>
            {/* <Route path="/adv" exact>
              <Contatos modulo={"advogado"} />
            </Route> */}
            {/* <Route path="/gpr-cssp">
              <Redirect to="/gprf" />
            </Route> */}
            <Route path="/gprf" exact>
              <Gpr modulo={"GPRF"} getToken={() => token} logoff={logoff} />
            </Route>
            {/* <Route path="/gpr" exact>
              <Gpr modulo={"GPR"} getToken={() => token} logoff={logoff} />
            </Route> */}
            <Route path="/auth" exact>
              <Auth />
            </Route>
            <Route path="*">
              <Redirect to="/contatos-zes/" />
            </Route>
          </Switch>
        </div>
        <Footer />
      </div>
    </Router>
  );

}

export default App;